import React, { useEffect, useState } from "react";
import { IoPlayCircle } from "react-icons/io5";
import HighlightsMobileCarosel from "./HighlightsMobileCarosel";
import { higlightsbanner } from "../../Constants/Data";
import BigMatchHighlightsMain from "./BigMatchHighlightsMain";

function BigMatchHighlights() {
  const [highlightsData, setHighlightsData] = useState([]);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [countText, setCountText] = useState("1 of 0");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedHighlightId, setSelectedHighlightId] = useState(null);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHighlightsData();
  }, []);

  const fetchHighlightsData = () => {
    setLoading(true);

    fetch(`${process.env.REACT_APP_API_URL_HIGHLIGHTS_BIGMATCH}`)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        // ✅ show only if success + data available
        if (data?.success && data?.data) {
          setHighlightsData([data.data]); // object -> array
          setCurrentItemIndex(0);
          setCountText("1 of 1");
        } else {
          setHighlightsData([]);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        setHighlightsData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleHighlightClick = (highlightId) => {
    setSelectedHighlightId(highlightId);
    setModalOpen(true);

    const index = highlightsData.findIndex((item) => item.id === highlightId);
    if (index !== -1) {
      setCurrentItemIndex(index);
      updateCountNumber(index);
    }
  };

  const handleClose = () => setModalOpen(false);

  const nextItem = () => {
    setCurrentItemIndex((prevIndex) => {
      const nextIndex =
        prevIndex === highlightsData.length - 1 ? 0 : prevIndex + 1;
      updateCountNumber(nextIndex);
      return nextIndex;
    });
  };

  const prevItem = () => {
    setCurrentItemIndex((prevIndex) => {
      const prevIndexNew =
        prevIndex === 0 ? highlightsData.length - 1 : prevIndex - 1;
      updateCountNumber(prevIndexNew);
      return prevIndexNew;
    });
  };

  const updateCountNumber = (index) => {
    const currentCount = index + 1;
    const totalCount = highlightsData.length;
    setCountText(`${currentCount} of ${totalCount}`);
  };

  // ✅ IMPORTANT: Hide this component when API has no data
  if (loading) return null;
  if (!highlightsData.length) return null;

  return (
    <div
      className="flex md:flex-row flex-col px-[16px] md:px-[24px] pt-[50px] md:pt-0 md:justify-center md:items-end text-start text-white font-Rubik md:h-[616px] md:w-full object-cover"
      style={{
        backgroundImage: `url(${higlightsbanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="pb-[80px] md:px-[24px] px-[16px] overflow-hidden">
        <div className="container mx-auto">
          <div className="flex flex-col gap-[16px]">
            {/* Heading */}
            <div className="flex md:justify-between justify-center pr-[30px]">
              <div className="flex text-white italic font-medium gap-[12px] items-center sports-news-heading">
                <IoPlayCircle className="text-[26px]" />
               <h3 className="md:text-[24px] text-[18px]">
                              Battle of the North 119<sup>th</sup> Encounter
              </h3>
              </div>

              {/* If you want to show count */}
              {/* <div className="hidden md:block text-sm opacity-80">{countText}</div> */}
            </div>

            {/* Desktop */}
            <div className="md:block hidden">
              <BigMatchHighlightsMain
                highlightsData={highlightsData}
                handleHighlightClick={handleHighlightClick}
                modalOpen={modalOpen}
                selectedHighlightId={selectedHighlightId}
                handleClose={handleClose}
                nextItem={nextItem}
                prevItem={prevItem}
                updateCountNumber={updateCountNumber}
                currentItemIndex={currentItemIndex}
              />
            </div>

            {/* Mobile */}
            <div className="md:hidden block">
              <HighlightsMobileCarosel
                highlightsData={highlightsData}
                handleHighlightClick={handleHighlightClick}
                modalOpen={modalOpen}
                selectedHighlightId={selectedHighlightId}
                handleClose={handleClose}
                nextItem={nextItem}
                prevItem={prevItem}
                updateCountNumber={updateCountNumber}
                currentItemIndex={currentItemIndex}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BigMatchHighlights;